/// Menu
import MetisMenu from "metismenujs";
import React, { Component, useContext, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import img from "../../../images/جامعة الأميرة نورة.png";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
    //  this.mm("dispose");
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const [universities, setUniversities] = useState([]);

  const [colleges, setColleges] = useState([]);

  const fetchColleges = async () => {
    try {
      const res = await fetch(
        "https://plo.areez.co/api/colleges?page=1&per_page=90"
      );
      const data = await res.json();
      setColleges(data.data);
    } catch (err) {
      console.error("فشل في جلب الكليات", err);
    }
  };


  const fetchUniversities = async () => {
    try {
      const response = await fetch("https://plo.areez.co/api/universities");

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();
      setUniversities(data);
    } catch (error) {
      console.error("خطأ:", error);
      setUniversities([]);
    }
  };

  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    //sidebar icon Heart blast
    // var handleheartBlast = document.querySelector('.heart');
    //       function heartBlast() {
    //           return handleheartBlast.classList.toggle("heart-blast");
    //       }

    //       handleheartBlast.addEventListener('click', heartBlast);
    fetchUniversities();
  }, []);
  let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let fullPath = window.location.pathname;
  // const isProjectsActive = fullPath.includes("/projects");
  
  const isProgramsActive = fullPath.includes("/programs");
  const isCollegesActive = fullPath.includes("/colleges");
  const isUniversitiesActive = fullPath.includes("/universities");
  /// Active menu
  let projects = ["projects"],
    students = ["students"],
    faculty = ["faculty"],
    app = [
      "app-profile",
      "post-details",
      "app-calender",
      "email-compose",
      "email-inbox",
      "email-read",
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "post-details",
      "ecom-product-detail",
    ],
    email = ["email-compose", "email-inbox", "email-read"],
    shop = [
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "ecom-product-detail",
    ],
    charts = [
      "chart-rechart",
      "chart-flot",
      "chart-chartjs",
      "chart-chartist",
      "chart-sparkline",
      "chart-apexchart",
    ],
    bootstrap = [
      "ui-accordion",
      "ui-badge",
      "ui-alert",
      "ui-button",
      "ui-modal",
      "ui-button-group",
      "ui-list-group",
      "ui-media-object",
      "ui-card",
      "ui-carousel",
      "ui-dropdown",
      "ui-popover",
      "ui-progressbar",
      "ui-tab",
      "ui-typography",
      "ui-pagination",
      "ui-grid",
    ],
    plugins = [
      "uc-select2",
      "uc-nestable",
      "uc-sweetalert",
      "uc-toastr",
      "uc-noui-slider",
      "map-jqvmap",
    ],
    widget = ["widget-basic"],
    forms = [
      "form-element",
      "form-wizard",
      "form-editor-summernote",
      "form-pickers",
      "form-validation-jquery",
    ],
    table = ["table-bootstrap-basic", "table-datatable-basic"],
    pages = [
      "page-register",
      "page-login",
      "page-lock-screen",
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ],
    error = [
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ];

  return (
    <div
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="deznav-scroll mt-5">
        <MM className="metismenu" id="menu">
          <li className={`${path === "" ? "mm-active" : ""}`}>
            <Link to="/">
              <i className="flaticon-381-networking"></i>
              <span className="nav-text">لوحة التحكم</span>
            </Link>
          </li>

          <li
            className={`${fullPath.includes("/students") ? "mm-active" : ""}`}
          >
            <Link to="/students" className="mt-1">
              <i className="fa fa-users"></i>
              <span className="nav-text">الطلاب</span>
            </Link>
          </li>

          <li className={`${fullPath.includes('faculty') ?  "mm-active" : ""}`}>
            <Link to="/faculty" className="mt-1">
              <i className="fa fa-id-badge"></i>
              <span className="nav-text">هيئة التدريس</span>
            </Link>
          </li>
          <li >
            <Link to="/performance-indicator" className="mt-1">
              <i className="fa fa-lightbulb-o"></i>
              <span className="nav-text">نواتج التعلم</span>
            </Link>
          </li>
          {/* <li>
  <a
    href="https://plo-dashboard.areez.co/"
    className="mt-1"
    rel="noopener noreferrer"
  >
    <i className="fa fa-lightbulb-o"></i>
    <span className="nav-text">نواتج التعلم</span>
  </a>
</li> */}

          <li className={`${fullPath.includes('learning-outcomes') ?  "mm-active" : ""}`}>
            <Link to="/learning-outcomes" className="mt-1">
              <i className="fa fa-line-chart"></i>
              <span className="nav-text">مؤشرات الأداء الرئيسية</span>
            </Link>
          </li>
          <li className={`${isUniversitiesActive ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-networking"></i>
              <span className="nav-text">الجامعات</span>
            </Link>
            <ul aria-expanded="false">
  {universities.map((u) => (
    <li key={u.id} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <img
        src={u.logo_url}
        alt={`شعار ${u.name}`}
        style={{
          width: "40px",
          height: "40px",
          objectFit: "contain",
          
        }}
      />
      <Link to={`/universities/${u.id}/${u.name}`}>{u.name}</Link>
    </li>
  ))}
</ul>

          </li>
{/* 
          <li className={`${isCollegesActive ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-networking"></i>
              <span className="nav-text">الكليات</span>
            </Link>
            <ul aria-expanded="false">
              {colleges.map((college) => (
                <li key={college.id}>
                  <Link to={`/colleges/${college.id}`}>{college.name}</Link>
                </li>
              ))}
            </ul>
          </li>

          <li className={`${isProgramsActive ? "mm-active" : ""}`}>
            <Link to="/programs" className="mt-1">
              <i className="flaticon-381-controls-3"></i>
              <span className="nav-text">البرامج</span>
            </Link>
          </li> */}
        </MM>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
